export const MUI_SPACING_UNIT = 8; // px

export const HEADER_HEIGHT = 60; // px
export const FOOTER_HEIGHT = 35; // px
export const SECTION_HEADER_HEIGHT = 51; // px
export const STICKY_HEADER_HEIGHT = 95; // px

export const BASE_PADDING = 16; // px
export const HORIZONTAL_MARGIN = 2; // MUI theme spacing unit => 16px
export const VERTICAL_MARGIN = 1.5; // MUI theme spacing unit => 12px

export const FULL_HEIGHT = `calc(100vh - ${FOOTER_HEIGHT}px - ${HEADER_HEIGHT}px - 2*${BASE_PADDING}px)`;

// Preferred CSS vw unit value based on the set width of our main content container (xl, extra-large: 1536px)
// vw_value = (ideal_font_size / viewport_width) * 100
export const DEFAULT_VW = `${(16 / 1536) * 100}vw`; // 1.042vw

export const BREAKPOINT_SM_MIN = 375; // px

export const SEARCH_BAR_MIN_HEIGHT = 40; // px

export const FILTER_SECTION_HEIGHT = '28vh';
export const FILTER_ROW_HEIGHT = 26; // px
export const FILTER_SECTION_MAX_VISIBLE_ROWS = 5;
export const FILTER_SECTION_CAPPED_HEIGHT = `${FILTER_ROW_HEIGHT * FILTER_SECTION_MAX_VISIBLE_ROWS}px`;

export const PROFILE_PAGE_NAVIGATION_WIDTH = '150'; // px

export const POPPER_Z_INDEX = 1500; // Note(Filip): This should be the highest z-index in the app to ensure poppers are always on top

export const NAME_EDIT_POPOVER_Z_INDEX = 20;
